import React, { useEffect, useState } from "react";
import center from "@turf/center";
import area from "@turf/area";
import priorityLow from "../../images/priority_low.png";
import priorityMedium from "../../images/priority_medium.png";
import priorityHigh from "../../images/priority_high.png";
import { requestPriority } from "../../constants/formOptions";

function StepConfirm({ formData, updateFormData, setCurrentStep }) {
  const [geometryInfo, setGeometryInfo] = useState({ center: null, area: null });

  useEffect(() => {
    const geoCenter = formData.areaOfInterest && center(formData.areaOfInterest);
    const [lng, lat] = geoCenter?.geometry.coordinates || [0, 0];

    const geoArea = formData.areaOfInterest && area(formData.areaOfInterest) / 1_000_000;

    setGeometryInfo({ center: { lat, lng }, area: geoArea?.toFixed(2) });
  }, [formData]);

  return (
    <div className="step-confirm">
      <h4>Request Confirmation</h4>
      <div className="summary">
        <div className="summary-row">
          <span>
            <strong>Name:</strong> {formData.name || "Not specified"}
          </span>
          <span>
            <strong>Project:</strong> {formData.project?.name || "Not specified"}
          </span>
          <button onClick={() => setCurrentStep(0)} className="edit-button">
            <i className="icon-edit"></i>
          </button>
        </div>
        <div className="summary-row">
          <span>
            <strong>Area: </strong>{geometryInfo.area && `${geometryInfo.area} km²`} { geometryInfo.center?.lat && <span>{geometryInfo.center?.lat?.toFixed(5)}, {geometryInfo.center?.lng?.toFixed(5)}</span>}
          </span>
          <span>
            <strong>Time: </strong>
            {formData.timeOfInterests.map((i) => `${i.monitoring ? 'Monitoring' : 'Assessment'} ${i.from} to ${i.to}`).join(", ")}
          </span>
          <button onClick={() => setCurrentStep(1)} className="edit-button">
            <i className="icon-edit"></i>
          </button>
        </div>
        <div className="summary-row">
          <span>
            <strong>Main Objective:</strong> {formData.selectedObjectives.join(", ") || "Not specified"} ({formData.structures.map((i) => i.type).join(", ") || "None"})
          </span>
          <button onClick={() => setCurrentStep(2)} className="edit-button">
            <i className="icon-edit"></i>
          </button>
        </div>
        <div className="summary-row">
          <span>
            <strong>Existing Issue:</strong> {formData.geohazards.map(g => g.description).join(", ") || "None"}
          </span>
          <button onClick={() => setCurrentStep(3)} className="edit-button">
            <i className="icon-edit"></i>
          </button>
        </div>
        <div className="summary-row">
          <span>
            <strong>Existing Data:</strong> {formData.dataFiles.map((i) => `${i.name} (${i.type})`).join(", ") || "None"}
          </span>
          <button onClick={() => setCurrentStep(4)} className="edit-button">
            <i className="icon-edit"></i>
          </button>
        </div>
      </div>
      <br /><br />
      <p>What is the level of priority of the request?</p>
      <div className="request-priority-wrapper">
        {requestPriority.map((option, index) => (
          <div
            key={index}
            onClick={() => updateFormData("requestPriority", option)}
            className={"request-priority-container" + (formData.requestPriority === option ? " active" : "")}
          >
            <img
              src={
                option === "low"
                  ? priorityLow
                  : option === "medium"
                  ? priorityMedium
                  : priorityHigh
              }
              alt={option}
              className="request-priority-img"
            />
            <div className="request-priority-text">{option}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default StepConfirm;
